import React, { useState } from "react";

export const ButtonIcon = React.memo(
	({
		icon = "",
		color = "black",
		title = "",
		hoverColor = "",
		opacity = "1",
		classes = "",
		clickHandler = () => {}
	}) => {
		const [onHover, setOnHover] = useState(false);
		let ButtonIconComponent = null;
		switch (icon) {
			case "close":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.13802 0.195312L0.195312 1.13802L5.05729 6L0.195312 10.862L1.13802 11.8047L6 6.94271L10.862 11.8047L11.8047 10.862L6.94271 6L11.8047 1.13802L10.862 0.195312L6 5.05729L1.13802 0.195312Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "user":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="12"
							viewBox="0 0 12 12"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
						>
							<path
								d="M6 0C5.29276 0 4.61448 0.280951 4.11438 0.781048C3.61428 1.28115 3.33333 1.95942 3.33333 2.66667C3.33333 3.37391 3.61428 4.05219 4.11438 4.55229C4.61448 5.05238 5.29276 5.33333 6 5.33333C6.70724 5.33333 7.38552 5.05238 7.88562 4.55229C8.38572 4.05219 8.66667 3.37391 8.66667 2.66667C8.66667 1.95942 8.38572 1.28115 7.88562 0.781048C7.38552 0.280951 6.70724 0 6 0ZM6 7.33333C3.99733 7.33333 0 8.33867 0 10.3333V12H12V10.3333C12 8.33867 8.00267 7.33333 6 7.33333Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "info":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M7.00016 0.333252C3.32616 0.333252 0.333496 3.32592 0.333496 6.99992C0.333496 10.6739 3.32616 13.6666 7.00016 13.6666C10.6742 13.6666 13.6668 10.6739 13.6668 6.99992C13.6668 3.32592 10.6742 0.333252 7.00016 0.333252ZM7.00016 1.66659C9.95358 1.66659 12.3335 4.0465 12.3335 6.99992C12.3335 9.95333 9.95358 12.3333 7.00016 12.3333C4.04675 12.3333 1.66683 9.95333 1.66683 6.99992C1.66683 4.0465 4.04675 1.66659 7.00016 1.66659ZM6.3335 3.66659V4.99992H7.66683V3.66659H6.3335ZM6.3335 6.33325V10.3333H7.66683V6.33325H6.3335Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "check":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M7 0.5C3.41025 0.5 0.5 3.41025 0.5 7C0.5 10.5898 3.41025 13.5 7 13.5C10.5898 13.5 13.5 10.5898 13.5 7C13.5 3.41025 10.5898 0.5 7 0.5ZM6.25 9.5L3.5 6.75L4 6L6.25 7.5L9.73925 4.5L10.5 5.25L6.25 9.5Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "up":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6 0.375L8.25 3.1875H6.73894L6.375 11.625H5.625L5.26106 3.1875H3.75L6 0.375Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "down":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="12"
							viewBox="0 0 12 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M6 11.625L3.75 8.8125H5.26106L5.625 0.375H6.375L6.73894 8.8125H8.25L6 11.625Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "triangle-up":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="8"
							height="5"
							viewBox="0 0 8 5"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M4 0.5L0 4.5H8L4 0.5Z" fill={color} />
						</svg>
					);
				};
				break;
			case "triangle-down":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="9"
							height="5"
							viewBox="0 0 9 5"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M0.5 0.5L4.5 4.5L8.5 0.5H0.5Z" fill={color} />
						</svg>
					);
				};
				break;
			case "chevron":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8.3335 4.94141L7.0835 6.19141L10.8921 10L7.0835 13.8086L8.3335 15.0586L13.3921 10L8.3335 4.94141Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "share":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="14"
							viewBox="0 0 12 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M5.99999 0.333496L3.33332 3.00016H5.33332V11.0002H6.66666V3.00016H8.66666L5.99999 0.333496ZM1.99999 3.66683C1.27128 3.66683 0.666656 4.27145 0.666656 5.00016V12.3335C0.666656 13.0622 1.27128 13.6668 1.99999 13.6668H9.99999C10.7287 13.6668 11.3333 13.0622 11.3333 12.3335V5.00016C11.3333 4.27145 10.7287 3.66683 9.99999 3.66683H9.33332V5.00016H9.99999V12.3335H1.99999V5.00016H2.66666V3.66683H1.99999Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "link":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="14"
							height="14"
							viewBox="0 0 14 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M10.125 0.549805C9.27499 0.549805 8.4249 0.874902 7.7749 1.5249L5.5249 3.7749L5.49999 3.79981C6.54999 3.59981 7.3248 4.1999 7.4248 4.2749L8.97509 2.7251C9.60009 2.1001 10.6249 2.1001 11.2749 2.7251C11.5999 3.0501 11.75 3.45 11.75 3.875C11.75 4.3 11.5999 4.6999 11.2749 5.0249L8.7749 7.5249C8.1499 8.1499 7.12509 8.1499 6.47509 7.5249C6.25009 7.2999 6.0998 7.025 6.0498 6.75C5.8248 6.875 5.2748 7.225 5.0498 7.875C5.1748 8.1 5.3499 8.3001 5.5249 8.4751C6.8249 9.7751 8.92509 9.7751 10.2251 8.4751L12.4751 6.2251C13.7751 4.9251 13.7751 2.8249 12.4751 1.5249C11.8251 0.874902 10.975 0.549805 10.125 0.549805ZM6.12499 4.54981C5.27499 4.54981 4.4249 4.8749 3.7749 5.5249L1.5249 7.7749C0.224896 9.0749 0.224896 11.1751 1.5249 12.4751C2.8249 13.7751 4.92509 13.7751 6.22509 12.4751L8.47509 10.2251L8.49999 10.2002C7.44999 10.4002 6.67519 9.8001 6.57519 9.7251L5.0249 11.2749C4.3999 11.8999 3.37509 11.8999 2.72509 11.2749C2.40009 10.9499 2.24999 10.55 2.24999 10.125C2.24999 9.7 2.40009 9.3001 2.72509 8.9751L5.22509 6.4751C5.85009 5.8501 6.8749 5.8501 7.5249 6.4751C7.7499 6.7001 7.90019 6.975 7.95019 7.25C8.17519 7.125 8.75019 6.775 8.95019 6.125C8.82519 5.9 8.65009 5.6999 8.47509 5.5249C7.82509 4.8749 6.97499 4.54981 6.12499 4.54981Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "pdf":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="14"
							viewBox="0 0 12 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.75 0.5V13.5H11.25V5.03857C11.25 4.52932 11.0702 4.03623 10.7427 3.64648L8.52734 1.01074C8.25534 0.686992 7.85415 0.5 7.43115 0.5H0.75ZM1.75 1.5H7.17383C7.99633 1.5 8.25 1.84127 8.25 2.14502C8.25 2.59127 7.75 3.25 7.75 3.25C9.93125 4.28241 10.2089 4.35942 10.2437 5H1.75V1.5ZM7.6709 5.97949H9.07129V6.42822H8.12744V6.99072H8.72803V7.43994H8.12744V8.51807H7.67139L7.6709 5.97949ZM3.02686 5.97998H3.97461C4.44136 5.97998 4.74512 6.28064 4.74512 6.76514C4.74512 7.27064 4.42005 7.55371 3.93555 7.55371H3.48291L3.4834 8.51855H3.02686V5.97998ZM5.20557 5.97998H5.94092C6.63392 5.97998 7.12939 6.51703 7.12939 7.23828C7.12989 8.03728 6.61325 8.5183 5.9165 8.51855H5.20557V5.97998ZM5.66162 6.42871L5.66211 8.0625H5.85986C6.35836 8.0625 6.66943 7.71594 6.66943 7.24219C6.66968 6.76119 6.36186 6.42846 5.85986 6.42871H5.66162ZM3.48291 6.4292V7.10107H3.96387C4.17962 7.10107 4.29639 6.99496 4.29639 6.78271C4.29664 6.54571 4.17987 6.42895 3.96387 6.4292H3.48291ZM1.75 9.5H10.25V12.5H1.75V9.5Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "csv":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="14"
							viewBox="0 0 12 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.75 0.5V13.5H11.25V5.03857C11.25 4.52932 11.0702 4.03623 10.7427 3.64648L8.52734 1.01074C8.25534 0.686992 7.85415 0.5 7.43115 0.5H0.75ZM1.75 1.5H7.17383C7.99633 1.5 8.25 1.84127 8.25 2.14502C8.25 2.59127 7.75 3.25 7.75 3.25C9.93125 4.28241 10.2089 4.35942 10.2437 5H1.75V1.5ZM5.92822 5.94727C6.19697 5.94727 6.43359 6.0001 6.62109 6.1416L6.49023 6.6084C6.32398 6.4704 6.16482 6.41406 5.92432 6.41406C5.71932 6.41406 5.57764 6.48474 5.57764 6.59424C5.57764 6.74624 5.73711 6.82399 6.00586 6.96924C6.43361 7.19899 6.72705 7.41455 6.72705 7.81055C6.7273 8.32355 6.39491 8.55713 5.86816 8.55713C5.61016 8.55713 5.30592 8.47239 5.09717 8.31689L5.27393 7.87451C5.44693 8.00526 5.65932 8.10107 5.88232 8.10107C6.13707 8.10107 6.25342 7.97713 6.25342 7.78613C6.25342 7.61638 6.09791 7.53871 5.86816 7.40771C5.58166 7.24496 5.12891 7.10707 5.12891 6.61182C5.12891 6.18032 5.51097 5.94727 5.92822 5.94727ZM3.77441 5.94775C4.16691 5.94775 4.46029 6.11396 4.65479 6.44971L4.24463 6.70459C4.10663 6.52084 3.96191 6.44629 3.77441 6.44629C3.42441 6.44629 3.21191 6.75402 3.21191 7.24902C3.21216 7.71202 3.45282 8.05518 3.78857 8.05518C3.94782 8.05518 4.1352 7.95245 4.25195 7.8252L4.63037 8.0835C4.41812 8.39825 4.13166 8.55762 3.77441 8.55762C3.16966 8.55762 2.73828 8.00227 2.73828 7.24902C2.73828 6.51002 3.13791 5.94775 3.77441 5.94775ZM7.11719 5.98291H7.60889L8.15332 7.93848L8.70166 5.98291H9.19629L8.43604 8.52197H7.85645L7.11719 5.98291ZM1.75 9.5H10.25V12.5H1.75V9.5Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "jpeg":
				ButtonIconComponent = () => {
					return (
						<svg
							className={`${icon} ` + classes}
							onClick={clickHandler}
							width="12"
							height="14"
							viewBox="0 0 12 14"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.75 0.5V13.5H11.25V5.03857C11.25 4.52932 11.0702 4.03623 10.7427 3.64648L8.52734 1.01074C8.25534 0.686992 7.85415 0.5 7.43115 0.5H0.75ZM1.75 1.5H7.17383C7.99633 1.5 8.25 1.84127 8.25 2.14502C8.25 2.59127 7.75 3.25 7.75 3.25C10.1903 4.405 10.2041 4.40464 10.2041 5.29639C10.2041 6.54639 10.25 12.5 10.25 12.5H1.75V1.5ZM4.25 5.5C3.83575 5.5 3.5 5.83575 3.5 6.25C3.5 6.66425 3.83575 7 4.25 7C4.66425 7 5 6.66425 5 6.25C5 5.83575 4.66425 5.5 4.25 5.5ZM7.75 6.5L7 7.75H6.25L5 9.5L4.75 9.25L5 8.5L4.5 8L3 9.5V10.25H9L8.5 8L7.75 6.5Z"
								fill={color}
							/>
						</svg>
					);
				};
				break;
			case "disconnect":
				ButtonIconComponent = () => {
					return (
						<svg
							width="50"
							height="50"
							viewBox="0 -25 672 672"
							xmlns="http://www.w3.org/2000/svg"
							version="1.1"
							style={{ top: "5px" }}
						>
							<g>
								<g transform="rotate(45 335.123 334.423)">
									<path d="m356.97075,352.29868l-45.938,45.938l-39.781,-39.781l45.938,-45.938c7.5781,-7.5781 7.5781,-19.418 0,-26.992c-7.5781,-7.5781 -19.418,-7.5781 -26.992,0l-45.938,45.938l-27.941,-27.941c-8.5234,-8.5234 -22.73,-8.5234 -31.258,0c-8.5234,8.5234 -8.5234,22.73 0,31.258l8.0508,8.0508l-22.258,22.258c-31.258,31.258 -35.992,79.562 -13.734,116.03l-40.727,40.727c-8.5234,8.5234 -8.5234,22.73 0,31.258c4.7344,3.7891 10.418,6.1562 15.629,6.1562c5.2109,0 11.367,-2.3672 15.629,-6.6289l40.727,-40.727c36.465,22.258 84.297,17.996 116.03,-13.734l22.258,-22.258l8.0508,8.0508c4.2617,4.2617 9.9453,6.6289 15.629,6.6289s11.367,-2.3672 15.629,-6.6289c8.5234,-8.5234 8.5234,-22.73 0,-31.258l-27.941,-27.941l45.938,-45.938c7.5781,-7.5781 7.5781,-19.418 0,-26.992c-7.5781,-7.1055 -19.418,-7.1055 -26.996,0.46875l-0.0046,-0.00465z" />
									<path d="m553.50075,115.97868c-8.5234,-8.5234 -22.73,-8.5234 -31.258,0l-40.727,40.727c-36.465,-22.258 -84.297,-17.996 -116.03,13.734l-22.258,22.258l-8.0508,-8.0469c-8.5234,-8.5234 -22.73,-8.5234 -31.258,0c-8.5234,8.5234 -8.5234,22.73 0,31.258l149.65,149.65c4.2617,4.2617 9.9453,6.6289 15.629,6.6289c5.6836,0 11.367,-2.3672 15.629,-6.6289c8.5234,-8.5234 8.5234,-22.73 0,-31.258l-8.0508,-8.0508l22.258,-22.258c31.258,-31.258 35.992,-79.562 13.734,-116.03l40.727,-40.727c9,-9.0039 9,-22.738 0,-31.262l0.0056,0.0057z" />
								</g>
							</g>
						</svg>
					);
				};
				break;
			case "live":
				ButtonIconComponent = () => {
					return (
						<svg
							width="50"
							height="50"
							version="1.1"
							viewBox="125 100 500 500"
							xmlns="http://www.w3.org/2000/svg"
							style={{ top: "5px" }}
						>
							<g>
								<path d="m535.12 216.88c-8.0508-8.0508-20.836-8.0508-28.887 0-8.0508 8.0508-8.0508 20.836 0 28.887 71.984 71.984 71.984 188.96 0 260.94-8.0508 8.0508-8.0508 20.836 0 28.887 3.7891 3.7891 8.9961 6.1562 14.207 6.1562 5.2109 0 10.418-1.8945 14.207-6.1562 88.086-88.082 88.086-231.1 0.47266-318.71z" />
								<path d="m467.4 284.12c-8.0508-8.0508-20.836-8.0508-28.887 0s-8.0508 20.836 0 28.887c34.57 34.57 35.047 91.402 0 125.97-8.0508 8.0508-8.0508 20.836 0 28.887 3.7891 3.7891 8.9961 6.1562 14.207 6.1562 5.2109 0 10.418-1.8945 14.207-6.1562 51.621-50.668 51.145-133.07 0.47266-183.75z" />
								<path d="m245.77 245.77c8.0508-8.0508 8.0508-20.836 0-28.887-8.0508-8.0508-20.836-8.0508-28.887 0-87.613 87.613-87.613 230.63 0 318.25 3.7891 3.7891 8.9961 6.1562 14.207 6.1562 5.2109 0 10.418-1.8945 14.207-6.1562 8.0508-8.0508 8.0508-20.836 0-28.887-71.512-71.512-71.512-188.49 0.47266-260.47z" />
								<path d="m313.02 313.02c8.0508-8.0508 8.0508-20.836 0-28.887-8.0508-8.0508-20.836-8.0508-28.887 0-50.672 50.672-50.672 133.08 0 183.75 3.7891 3.7891 8.9961 6.1562 14.207 6.1562 5.2109 0 10.418-1.8945 14.207-6.1562 8.0508-8.0508 8.0508-20.836 0-28.887-34.098-34.574-34.098-91.406 0.47266-125.98z" />
								<path d="m410.57 376c0 19.094-15.48 34.574-34.574 34.574s-34.57-15.48-34.57-34.574 15.477-34.57 34.57-34.57 34.574 15.477 34.574 34.57" />
							</g>
						</svg>
					);
				};
				break;
			case "calendar":
				ButtonIconComponent = () => {
					return (
						<div className={`${icon} ` + classes}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								viewBox="0 0 448 512"
								fill={color}
								fillOpacity={opacity}
							>
								<path d="M96 288C96 270.3 110.3 256 128 256C145.7 256 160 270.3 160 288C160 305.7 145.7 320 128 320C110.3 320 96 305.7 96 288zM320 352C337.7 352 352 366.3 352 384C352 401.7 337.7 416 320 416C302.3 416 288 401.7 288 384C288 366.3 302.3 352 320 352zM192 288C192 274.7 202.7 264 216 264H328C341.3 264 352 274.7 352 288C352 301.3 341.3 312 328 312H216C202.7 312 192 301.3 192 288zM232 360C245.3 360 256 370.7 256 384C256 397.3 245.3 408 232 408H120C106.7 408 96 397.3 96 384C96 370.7 106.7 360 120 360H232zM152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z" />
							</svg>
						</div>
					);
				};
				break;
			case "compare":
				ButtonIconComponent = () => {
					return (
						<div className={`${icon} ` + classes}>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								fillOpacity={opacity}
							>
								<g clipPath="url(#clip0_6178_7140)">
									<path
										d="M4.42992 5.14957H4.48925L4.42986 5.14963L4.42992 5.14957ZM4.42988 5.14957L4.42982 5.14963L4.41425 5.14964C4.41425 5.14962 4.41425 5.14959 4.41425 5.14957H4.42988ZM4.39447 5.14108L4.41506 5.16166C4.41513 5.16228 4.41522 5.16292 4.41531 5.16357C4.41618 5.16968 4.41776 5.1772 4.42057 5.18565C4.42628 5.20279 4.43694 5.2231 4.45599 5.24215C4.45948 5.24564 4.46497 5.2533 4.47629 5.27028C4.47679 5.27104 4.47732 5.27182 4.47786 5.27264C4.48646 5.28557 4.50001 5.30594 4.51533 5.32127L4.51555 5.32149L6.8493 7.63546L6.8491 7.63566L6.85409 7.63982C6.98283 7.7471 7.1377 7.81542 7.29765 7.81542C7.45338 7.81542 7.63059 7.75005 7.74496 7.6365C7.9954 7.40742 7.99118 7.00279 7.74624 6.75784L6.47007 5.48167H8.34586H12.4003C13.7429 5.48167 14.8172 6.57503 14.8172 7.89864C14.8172 8.53079 14.5684 9.12531 14.1266 9.5866C13.8804 9.83347 13.8805 10.2168 14.1272 10.4634L14.127 10.4636L14.1322 10.468C14.261 10.5753 14.4158 10.6436 14.5758 10.6436C14.724 10.6436 14.9074 10.6019 15.0267 10.4611C15.7121 9.77441 16.0748 8.86609 16.0748 7.89864C16.0748 5.87974 14.4394 4.2437 12.4197 4.26369H8.36564H6.48984L7.7648 2.98874C8.01475 2.76003 8.01095 2.35644 7.76727 2.11139C7.53819 1.86097 7.13356 1.86519 6.88863 2.11013L4.5351 4.46365L4.49555 4.50321C4.49416 4.5046 4.49408 4.50464 4.49262 4.50548C4.49106 4.50639 4.4879 4.50821 4.47978 4.51362C4.47387 4.51756 4.46132 4.52628 4.45098 4.54105C4.4465 4.54745 4.44298 4.55417 4.44033 4.56107C4.43158 4.57304 4.42619 4.58385 4.42277 4.59072L4.42217 4.59192C4.41762 4.60102 4.41695 4.60163 4.41654 4.602C4.4165 4.60203 4.41647 4.60206 4.41644 4.6021L4.39447 4.62406V4.6355C4.39246 4.63817 4.3904 4.64114 4.38847 4.64435C4.38037 4.65786 4.3754 4.67355 4.37476 4.69087C4.37464 4.69137 4.37447 4.69204 4.37425 4.69287C4.37304 4.69728 4.37129 4.70262 4.36865 4.71052L4.36839 4.71132C4.3661 4.71818 4.36306 4.72729 4.36065 4.73614C4.35842 4.74432 4.35492 4.75844 4.35492 4.77379V4.78459C4.33442 4.87133 4.33516 4.94135 4.35716 5.02932L4.36219 5.04947L4.37537 5.06265C4.37672 5.07457 4.37983 5.08457 4.38256 5.09185C4.38584 5.10059 4.38988 5.10865 4.3921 5.1131L4.3925 5.11389L4.39447 5.1179V5.14108ZM4.38578 5.07325C4.38576 5.07323 4.3857 5.07315 4.38559 5.07303L4.3856 5.07304C4.38575 5.07321 4.38581 5.07327 4.38578 5.07325ZM11.5853 11.2213V11.1816C11.5873 11.1789 11.5893 11.1759 11.5913 11.1727C11.5947 11.167 11.5975 11.161 11.5997 11.1546C11.6135 11.1329 11.6188 11.1102 11.6213 11.0951C11.625 11.0734 11.6248 11.0527 11.6248 11.0433V11.0325C11.6446 10.9488 11.6446 10.8807 11.6248 10.7971C11.6246 10.7867 11.6228 10.7694 11.6144 10.7526C11.6094 10.7425 11.6033 10.7348 11.5988 10.7297C11.5982 10.7281 11.5977 10.7266 11.5972 10.7252C11.5939 10.7165 11.5899 10.7084 11.5876 10.704L11.5872 10.7032L11.5849 10.6984C11.5825 10.6683 11.5676 10.6454 11.5579 10.6324C11.5516 10.624 11.5445 10.6161 11.5379 10.6091C11.5362 10.605 11.5342 10.6011 11.5319 10.5974C11.5291 10.5927 11.5261 10.5886 11.5233 10.5852L11.518 10.5746C11.5059 10.5503 11.4917 10.528 11.4718 10.5082C11.4551 10.4915 11.4367 10.4788 11.4169 10.468L9.11111 8.14249L9.11089 8.14227C8.86595 7.89733 8.46133 7.89311 8.23224 8.14353C7.98856 8.38857 7.98476 8.79217 8.23471 9.02087L9.50967 10.2958H7.63387H3.57948C2.25587 10.2958 1.16252 9.22148 1.16252 7.87886C1.16252 7.24671 1.41131 6.65218 1.85313 6.19089C2.09748 5.94589 2.10151 5.54174 1.85128 5.31283C1.60623 5.06915 1.20263 5.06535 0.973929 5.31531C0.28775 6.00214 -0.0752441 6.9109 -0.0752441 7.87886C-0.0752441 9.89777 1.56004 11.5534 3.59926 11.5534H7.65365H9.52944L8.25327 12.8295C8.00833 13.0745 8.00411 13.4791 8.25454 13.7082C8.36892 13.8217 8.54613 13.8871 8.70186 13.8871C8.86182 13.8871 9.01668 13.8188 9.14542 13.7115L9.14562 13.7117L9.15044 13.7069L11.504 11.3534C11.5101 11.3473 11.5151 11.3413 11.5192 11.3358H11.5655V11.2804C11.5675 11.2778 11.5696 11.2748 11.5715 11.2716C11.5802 11.2571 11.5853 11.2401 11.5853 11.2213Z"
										fill={color}
										strokeWidth="0.15"
									/>
								</g>
								<defs>
									<clipPath id="clip0_6178_7140">
										<rect width="16" height="16" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</div>
					);
				};
				break;
			case "resolve":
				ButtonIconComponent = () => {
					return (
						<svg
							width="20"
							height="20"
							viewBox="0 -40 80 120"
							fill="black"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M40.1195 79.5833C18.1795 79.5833 0.326172 61.7333 0.326172 39.79C0.329505 17.85 18.1795 0 40.1195 0C62.0595 0 79.9128 17.85 79.9128 39.7933C79.9128 61.7333 62.0595 79.5833 40.1195 79.5833ZM40.1195 6.12C21.5528 6.12 6.4495 21.2233 6.4495 39.79C6.4495 58.3533 21.5528 73.46 40.1195 73.46C58.6828 73.46 73.7895 58.3567 73.7895 39.79C73.7895 21.2267 58.6828 6.12 40.1195 6.12Z"
								fill="current"
							/>
							<path
								d="M34.8599 52.8C34.0766 52.8 33.2933 52.5 32.6966 51.9034L23.3233 42.5267C22.1266 41.3334 22.1266 39.3967 23.3233 38.2C24.5166 37.0034 26.4533 37.0034 27.6499 38.2L34.8599 45.41L52.5899 27.68C53.7833 26.4867 55.7199 26.4867 56.9199 27.68C58.1133 28.8767 58.1133 30.8134 56.9199 32.01L37.0233 51.9067C36.4266 52.5 35.6433 52.8 34.8599 52.8Z"
								fill="current"
							/>
						</svg>
					);
				};
				break;
			case "cancel":
				ButtonIconComponent = () => {
					return (
						<div
							title={title}
							className={`${icon} ` + classes}
							onClick={clickHandler}
							onMouseEnter={() => setOnHover(true)}
							onMouseLeave={() => setOnHover(false)}
						>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								fillOpacity={opacity}
							>
								<path
									d="M7.99992 14.6668C11.6818 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6818 1.3335 7.99992 1.3335C4.31802 1.3335 1.33325 4.31826 1.33325 8.00016C1.33325 11.6821 4.31802 14.6668 7.99992 14.6668Z"
									stroke={onHover && hoverColor ? hoverColor : color}
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="1.3"
								/>
								<path
									d="M10 6L6 10"
									stroke={onHover && hoverColor ? hoverColor : color}
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="1.3"
								/>
								<path
									d="M6 6L10 10"
									stroke={onHover && hoverColor ? hoverColor : color}
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="1.3"
								/>
							</svg>
						</div>
					);
				};
				break;
			case "previous":
				ButtonIconComponent = () => (
					<svg
						width="500"
						height="500"
						viewBox="0 0 500 500"
						xmlns="http://www.w3.org/2000/svg"
						version="1.1"
						fill={color}
					>
						<g>
							<path
								transform="rotate(180 237.261 251.464)"
								d="m348.21022,271.8296c-2.4766,2.4961 -186.64,216.37 -186.89,216.51l-0.04297,-0.08984c-4.2734,2.4141 -9.1602,3.9375 -14.426,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5234,-19.48 13.703,-24.602l-0.01562,-0.0625l161.78,-186.97l-161.78,-186.98l0.01562,-0.06641c-8.1797,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.152,1.5234 14.426,3.9609l0.04297,-0.11328c0.25781,0.12891 184.42,214.01 186.89,216.51c11.359,11.355 11.359,29.375 0.00391,40.738l-0.00391,-0.00637z"
							/>
						</g>
					</svg>
				);
				break;
			case "next":
				ButtonIconComponent = () => (
					<svg
						width="500"
						height="500"
						viewBox="0 0 500 500"
						xmlns="http://www.w3.org/2000/svg"
						version="1.1"
						fill={color}
					>
						<g>
							<path d="m355.21022,271.8296c-2.4766,2.4961 -186.64,216.37 -186.89,216.51l-0.04297,-0.08984c-4.2734,2.4141 -9.1602,3.9375 -14.426,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5234,-19.48 13.703,-24.602l-0.01562,-0.0625l161.78,-186.97l-161.78,-186.98l0.01562,-0.06641c-8.1797,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.152,1.5234 14.426,3.9609l0.04297,-0.11328c0.25781,0.12891 184.42,214.01 186.89,216.51c11.359,11.355 11.359,29.375 0.00391,40.738l-0.00391,-0.00637z" />
						</g>
					</svg>
				);
				break;
			case "arrow-right":
				ButtonIconComponent = () => (
					<svg
						className={`${icon} ` + classes}
						width="13"
						height="10"
						viewBox="0 0 13 10"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.33333 0.286438L6.33333 1.28644L9.38021 4.33331H0V5.66665H9.38021L6.33333 8.71352L7.33333 9.71352L12.0469 4.99998L7.33333 0.286438Z"
							fill={color}
						/>
					</svg>
				);
				break;
			case "last":
				ButtonIconComponent = () => (
					<svg
						width="500"
						height="500"
						viewBox="0 0 500 500"
						xmlns="http://www.w3.org/2000/svg"
						version="1.1"
						fill={color}
					>
						<g>
							<path d="m451.95,271.83c-2.4766,2.4961 -186.64,216.37 -186.89,216.51l-0.04297,-0.08984c-4.2734,2.4141 -9.1602,3.9375 -14.426,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5234,-19.48 13.703,-24.602l-0.01562,-0.0625l161.78,-186.97l-161.78,-186.98l0.01562,-0.06641c-8.1797,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.152,1.5234 14.426,3.9609l0.04297,-0.11328c0.25781,0.12891 184.42,214.01 186.89,216.51c11.359,11.355 11.359,29.375 0.00391,40.738l-0.00391,-0.00637z" />
							<path d="m267.21,271.83c-2.4688,2.4961 -186.64,216.37 -186.89,216.51l-0.06641,-0.08984c-4.2578,2.4141 -9.1406,3.9375 -14.402,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5156,-19.48 13.703,-24.602l-0.02343,-0.0625l161.79,-186.97l-161.79,-186.97l0.02343,-0.06641c-8.1875,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.148,1.5234 14.402,3.9609l0.06641,-0.11328c0.25391,0.12891 184.42,214.01 186.89,216.51c11.352,11.348 11.352,29.367 0,40.73l0,-0.00837z" />
						</g>
					</svg>
				);
				break;
			case "first":
				ButtonIconComponent = () => (
					<svg
						width="500"
						height="500"
						viewBox="0 0 500 500"
						xmlns="http://www.w3.org/2000/svg"
						version="1.1"
						fill={color}
					>
						<g transform="rotate(180 248.631 251.464)">
							<path d="m451.95,271.83c-2.4766,2.4961 -186.64,216.37 -186.89,216.51l-0.04297,-0.08984c-4.2734,2.4141 -9.1602,3.9375 -14.426,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5234,-19.48 13.703,-24.602l-0.01562,-0.0625l161.78,-186.97l-161.78,-186.98l0.01562,-0.06641c-8.1797,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.152,1.5234 14.426,3.9609l0.04297,-0.11328c0.25781,0.12891 184.42,214.01 186.89,216.51c11.359,11.355 11.359,29.375 0.00391,40.738l-0.00391,-0.00637z" />
							<path d="m267.21,271.83c-2.4688,2.4961 -186.64,216.37 -186.89,216.51l-0.06641,-0.08984c-4.2578,2.4141 -9.1406,3.9375 -14.402,3.9375c-16.031,0 -29.059,-13.008 -29.059,-29.086c0,-10.383 5.5156,-19.48 13.703,-24.602l-0.02343,-0.0625l161.79,-186.97l-161.79,-186.97l0.02343,-0.06641c-8.1875,-5.1172 -13.703,-14.211 -13.703,-24.594c0,-16.082 13.027,-29.086 29.059,-29.086c5.2656,0 10.148,1.5234 14.402,3.9609l0.06641,-0.11328c0.25391,0.12891 184.42,214.01 186.89,216.51c11.352,11.348 11.352,29.367 0,40.73l0,-0.00837z" />
						</g>
					</svg>
				);
				break;
			case "cross":
				ButtonIconComponent = () => (
					<div className={`${icon} ` + classes} onClick={clickHandler}>
						<svg
							height="20"
							width="20"
							viewBox="0 0 20 20"
							aria-hidden="true"
							focusable="false"
							fill={color}
							fillOpacity={opacity}
						>
							<path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
						</svg>
					</div>
				);
				break;
			case "logout":
				ButtonIconComponent = () => {
					return (
						<svg
							width="16px"
							height="14px"
							viewBox="0 0 16 14"
							version="1.1"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g id="PL-&lt;&gt;-v1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g
									id="Dashboard---user-details"
									transform="translate(-1076.000000, -140.000000)"
									fill="#ffffff"
									fill-rule="nonzero"
								>
									<g id="log-out" transform="translate(1048.000000, 66.000000)">
										<g id="icon-signout" transform="translate(28.000000, 74.000000)">
											<path
												d="M9.25,11 L6.25,11 L6.25,3 L9.25,3 L9.25,5.1 L10.5166667,5.1 L10.5166667,2.35 C10.5166667,2.01666667 10.25,1.75 9.91666667,1.75 L6.25,1.75 L6.25,0.5 C6.25,0.183333333 5.93333333,-0.0166666667 5.65,0.1 L0.566666667,2.38333333 C0.283333333,2.51666667 0.0833333333,2.8 0.0833333333,3.11666667 L0.0833333333,10.9 C0.0833333333,11.2166667 0.266666667,11.5 0.566666667,11.6333333 L5.65,13.9166667 C5.93333333,14.05 6.25,13.8333333 6.25,13.5166667 L6.25,12.2666667 L9.91666667,12.2666667 C10.25,12.2666667 10.5166667,12 10.5166667,11.6666667 L10.5166667,8.9 L9.25,8.9 L9.25,11 Z"
												id="Shape"
											></path>
											<path
												d="M15.7666667,6.68333333 L12.7333333,4.21666667 C12.4666667,4 12.05,4.18333333 12.05,4.55 L12.05,5.96666667 L7.45,5.96666667 C7.25,5.96666667 7.1,6.13333333 7.1,6.31666667 L7.1,7.71666667 C7.1,7.91666667 7.26666667,8.06666667 7.45,8.06666667 L12.05,8.06666667 L12.05,9.48333333 C12.05,9.83333333 12.4666667,10.0333333 12.7333333,9.81666667 L15.7666667,7.33333333 C15.9666667,7.16666667 15.9666667,6.85 15.7666667,6.68333333 Z"
												id="Shape"
											></path>
										</g>
									</g>
								</g>
							</g>
						</svg>
					);
				};
				break;
			case "tick":
				ButtonIconComponent = () => (
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0)">
							<path
								d="M8.52256 16.6117C13.0231 16.6117 16.6716 13.0981 16.6716 8.76384C16.6716 4.42961 13.0231 0.916016 8.52256 0.916016C4.02198 0.916016 0.373535 4.42961 0.373535 8.76384C0.373535 13.0981 4.02198 16.6117 8.52256 16.6117Z"
								fill="rgba(46, 204, 113, 0.05)"
							/>
							<path
								d="M8.52252 16.1209C12.7418 16.1209 16.1622 12.8269 16.1622 8.76359C16.1622 4.70024 12.7418 1.40625 8.52252 1.40625C4.30323 1.40625 0.882812 4.70024 0.882812 8.76359C0.882812 12.8269 4.30323 16.1209 8.52252 16.1209Z"
								stroke="#2ECC71"
							/>
							<path
								d="M4.69458 8.60103L7.35116 11.3801L12.2834 6.33301"
								stroke="#2ECC71"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</g>
						<defs>
							<clipPath id="clip0">
								<rect
									width="16.298"
									height="15.6957"
									fill="white"
									transform="translate(0.373535 0.916016)"
								/>
							</clipPath>
						</defs>
					</svg>
				);
				break;
			case "refresh":
				ButtonIconComponent = () => (
					<div className={`${icon} ` + classes} title={title} onClick={clickHandler}>
						<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
							<g clip-path="url(#clip0_8027_345)">
								<path
									d="M14.3779 2.61486C14.077 2.58743 13.811 2.80905 13.7836 3.10983L13.7111 3.90469C12.4818 1.97405 10.3478 0.683594 7.8751 0.683594C5.21508 0.683594 2.87087 2.20177 1.70717 4.48038C1.5698 4.74936 1.67649 5.07877 1.94547 5.21615C2.21451 5.35352 2.54386 5.24686 2.68124 4.97785C3.66608 3.04946 5.64377 1.77734 7.8751 1.77734C9.90885 1.77734 11.7442 2.83639 12.7957 4.49553L12.0159 3.93862C11.7701 3.7631 11.4286 3.82003 11.2531 4.0658C11.0775 4.31159 11.1345 4.65311 11.3802 4.82866L13.7448 6.51744C14.0913 6.76449 14.5693 6.53833 14.6072 6.12207L14.8728 3.20914C14.9002 2.90834 14.6786 2.64228 14.3779 2.61486Z"
									fill={color}
								/>
								<path
									d="M13.8046 10.151C13.5356 10.0137 13.2062 10.1204 13.0688 10.3893C12.084 12.3177 10.1063 13.5899 7.87497 13.5899C5.84122 13.5899 4.00586 12.5308 2.95438 10.8717L3.73414 11.4286C3.97994 11.6041 4.32146 11.5472 4.49701 11.3014C4.67252 11.0556 4.6156 10.7141 4.36983 10.5385L2.00528 8.84976C1.66296 8.60519 1.18111 8.82457 1.14283 9.24512L0.877294 12.1581C0.849869 12.4588 1.07149 12.7249 1.37224 12.7523C1.67341 12.7797 1.93911 12.5578 1.96651 12.2573L2.03897 11.4625C3.26829 13.3931 5.4023 14.6836 7.87497 14.6836C10.535 14.6836 12.8792 13.1654 14.0429 10.8868C14.1803 10.6178 14.0736 10.2884 13.8046 10.151Z"
									fill={color}
								/>
							</g>
							<defs>
								<clipPath id="clip0_8027_345">
									<rect width="14" height="14" fill="white" transform="translate(0.875 0.683594)" />
								</clipPath>
							</defs>
						</svg>
					</div>
				);
				break;
			case "freshchat":
				ButtonIconComponent = () => (
					<svg width="18" height="16" version="1.1" viewBox="18 20 60 60" xmlns="http://www.w3.org/2000/svg">
						<g fill="#fff">
							<path
								strokeWidth="2"
								stroke="#fff"
								d="m22.012 79.738c0.46094 0 0.90625-0.1875 1.2305-0.51562l13.488-13.48h34.262c4.832 0 8.7461-3.9141 8.7461-8.7461v-27.988c0-4.832-3.9141-8.7461-8.7461-8.7461h-41.984c-2.3203 0-4.543 0.92188-6.1836 2.5625s-2.5625 3.8633-2.5625 6.1836v48.98c0 0.46484 0.18359 0.91016 0.51172 1.2383 0.32812 0.32813 0.77344 0.51172 1.2383 0.51172zm48.98-55.98c2.8984 0 5.25 2.3516 5.25 5.25v27.988c0 2.8984-2.3516 5.25-5.25 5.25h-34.988c-0.46094 0-0.90625 0.1875-1.2305 0.51562l-11.012 11.004v-44.758c0-2.8984 2.3477-5.25 5.2461-5.25z"
							/>
							<path
								strokeWidth="2"
								stroke="#fff"
								d="m56.996 43.004c0 4.6641 7 4.6641 7 0 0-4.668-7-4.668-7 0"
							/>
							<path
								strokeWidth="2"
								stroke="#fff"
								d="m46.5 43.004c0 4.6641 7 4.6641 7 0 0-4.668-7-4.668-7 0"
							/>
							<path
								strokeWidth="2"
								stroke="#fff"
								d="m36.004 43.004c0 4.6641 7 4.6641 7 0 0-4.668-7-4.668-7 0"
							/>
						</g>
					</svg>
				);
				break;
			case "dropdown-arrow":
				ButtonIconComponent = () => (
					<div title={title} className={`${icon} ` + classes} onClick={clickHandler}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill={color}>
							<path
								fillRule="evenodd"
								d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
								clipRule="evenodd"
							/>
						</svg>
					</div>
				);
				break;
			case "download":
				ButtonIconComponent = () => (
					<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M12.4001 10H10.0001V3.5C10.0001 3.22386 9.77621 3 9.50006 3H8.50006C8.22392 3 8.00006 3.22386 8.00006 3.5V10H5.60006C5.49881 9.99982 5.40744 10.0607 5.36867 10.1543C5.3299 10.2478 5.35138 10.3555 5.42306 10.427L8.64406 13.647C8.83931 13.8422 9.15581 13.8422 9.35106 13.647L12.5711 10.427C12.6411 10.3559 12.6623 10.2502 12.6252 10.1576C12.5882 10.065 12.4998 10.0031 12.4001 10Z"
							fill="white"
						/>
						<path
							d="M15 15H3V13.5C3 13.2239 2.77614 13 2.5 13H1.5C1.22386 13 1 13.2239 1 13.5V16.5C1 16.7761 1.22386 17 1.5 17H16.5C16.7761 17 17 16.7761 17 16.5V13.5C17 13.2239 16.7761 13 16.5 13H15.5C15.2239 13 15 13.2239 15 13.5V15Z"
							fill="white"
						/>
					</svg>
				);
				break;
			case "code":
				ButtonIconComponent = () => (
					<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M8 0L6.66667 12H8L9.33333 0H8ZM3.80469 2.19531L0 6L3.80469 9.80469L4.7474 8.86198L1.88542 6L4.7474 3.13802L3.80469 2.19531ZM12.1953 2.19531L11.2526 3.13802L14.1146 6L11.2526 8.86198L12.1953 9.80469L16 6L12.1953 2.19531Z"
							fill="#222222"
						/>
					</svg>
				);
				break;
			case "filter":
				ButtonIconComponent = () => (
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
						<path
							d="M5.66732 0.333496C4.79958 0.333496 4.06589 0.892662 3.78971 1.66683H0.333984V3.00016H3.78971C4.06589 3.77433 4.79958 4.3335 5.66732 4.3335C6.76998 4.3335 7.66732 3.43616 7.66732 2.3335C7.66732 1.23083 6.76998 0.333496 5.66732 0.333496ZM9.00065 1.66683V3.00016H13.6673V1.66683H9.00065ZM9.00065 5.00016C8.13291 5.00016 7.39923 5.55933 7.12305 6.3335H0.333984V7.66683H7.12305C7.39923 8.441 8.13291 9.00016 9.00065 9.00016C10.1033 9.00016 11.0007 8.10283 11.0007 7.00016C11.0007 5.8975 10.1033 5.00016 9.00065 5.00016ZM12.334 6.3335V7.66683H13.6673V6.3335H12.334ZM3.66732 9.66683C2.79958 9.66683 2.06589 10.226 1.78971 11.0002H0.333984V12.3335H1.78971C2.06589 13.1077 2.79958 13.6668 3.66732 13.6668C4.76998 13.6668 5.66732 12.7695 5.66732 11.6668C5.66732 10.5642 4.76998 9.66683 3.66732 9.66683ZM7.00065 11.0002V12.3335H13.6673V11.0002H7.00065Z"
							fill="#222222"
						/>
					</svg>
				);
				break;
			case "eye":
				ButtonIconComponent = () => (
					<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M0.583496 7.80851C0.583496 7.80851 2.91683 3.14185 7.00016 3.14185C11.0835 3.14185 13.4168 7.80851 13.4168 7.80851C13.4168 7.80851 11.0835 12.4752 7.00016 12.4752C2.91683 12.4752 0.583496 7.80851 0.583496 7.80851Z"
							stroke={color}
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-opacity={opacity}
						/>
						<path
							d="M7 9.55859C7.9665 9.55859 8.75 8.77509 8.75 7.80859C8.75 6.8421 7.9665 6.05859 7 6.05859C6.0335 6.05859 5.25 6.8421 5.25 7.80859C5.25 8.77509 6.0335 9.55859 7 9.55859Z"
							stroke={color}
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-opacity={opacity}
						/>
					</svg>
				);
				break;
			case "alert":
				ButtonIconComponent = () => (
					<svg
						className={`${icon} ` + classes}
						onClick={clickHandler}
						width="500"
						height="500"
						version="1.1"
						viewBox="100 25 500 500"
						xmlns="http://www.w3.org/2000/svg"
						fill={color}
						fillOpacity={opacity}
					>
						<g>
							<path d="m350 52.5c-60.336 0-118.2 23.969-160.87 66.633-42.664 42.664-66.633 100.53-66.633 160.87s23.969 118.2 66.633 160.87c42.664 42.664 100.53 66.633 160.87 66.633s118.2-23.969 160.87-66.633c42.664-42.664 66.633-100.53 66.633-160.87s-23.969-118.2-66.633-160.87c-42.664-42.664-100.53-66.633-160.87-66.633zm0 420c-51.055 0-100.02-20.281-136.12-56.383-36.102-36.102-56.383-85.062-56.383-136.12s20.281-100.02 56.383-136.12c36.102-36.102 85.062-56.383 136.12-56.383s100.02 20.281 136.12 56.383c36.102 36.102 56.383 85.062 56.383 136.12s-20.281 100.02-56.383 136.12c-36.102 36.102-85.062 56.383-136.12 56.383z" />
							<path d="m350 157.5c-4.6406 0-9.0938 1.8438-12.375 5.125s-5.125 7.7344-5.125 12.375v140c0 6.2539 3.3359 12.031 8.75 15.156s12.086 3.125 17.5 0 8.75-8.9023 8.75-15.156v-140c0-4.6406-1.8438-9.0938-5.125-12.375s-7.7344-5.125-12.375-5.125z" />
							<path d="m367.5 385c0 9.6641-7.8359 17.5-17.5 17.5s-17.5-7.8359-17.5-17.5 7.8359-17.5 17.5-17.5 17.5 7.8359 17.5 17.5" />
						</g>
					</svg>
				);
				break;
			case "triangle-alert":
				ButtonIconComponent = () => (
					<svg
						className={`${icon} ` + classes}
						onClick={clickHandler}
						width="18"
						height="16"
						viewBox="0 0 18 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.94143 1.12109L1.02346 13.7461C0.585961 14.5352 1.16799 15.5 2.08205 15.5H15.9219C16.8321 15.5 17.4141 14.5352 16.9805 13.7461L10.0586 1.12109C9.60159 0.292969 8.39846 0.292969 7.94143 1.12109ZM9.68752 6.35938L9.5469 11.125H8.45315L8.31252 6.35938H9.68752ZM9.00002 13.7188C8.58205 13.7188 8.25393 13.4023 8.25393 13C8.25393 12.5977 8.58205 12.2812 9.00002 12.2812C9.41799 12.2812 9.74612 12.5977 9.74612 13C9.74612 13.4023 9.41799 13.7188 9.00002 13.7188Z"
							fill={color}
						/>
					</svg>
				);
				break;
			case "external-link":
				ButtonIconComponent = () => (
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
						<path
							d="M0 0V12H12V6H10.6667V10.6667H1.33333V1.33333H6V0H0ZM7.33333 0V1.33333H9.72396L3.52865 7.52865L4.47135 8.47135L10.6667 2.27604V4.66667H12V0H7.33333Z"
							fill="white"
						/>
					</svg>
				);
				break;
			default:
				break;
		}
		if (ButtonIconComponent) {
			return <ButtonIconComponent />;
		}
		return null;
	}
);
